import _ from "lodash"

export enum CheckboxVisibilityType {
  VISIBLE = 'visible',
  HIDDEN = 'hidden'
}

export enum SelectType {
  ALL = "all",
  SOME = "some",
  NONE = "none"
}

export const changeFilesListCheckboxState = (selectItemsLength, itemsLength, state) => {
  if (selectItemsLength === 0) {
    state.checkboxVisibility = CheckboxVisibilityType.HIDDEN
    state.selectType = SelectType.NONE
  } else {
    if (selectItemsLength < itemsLength && selectItemsLength > 0) {
      state.checkboxVisibility = CheckboxVisibilityType.VISIBLE
      state.selectType = SelectType.SOME
    } else {
      if (selectItemsLength === itemsLength) {
        state.selectType = SelectType.ALL
        state.checkboxVisibility = CheckboxVisibilityType.VISIBLE
      }
    }
  }
}

export const selectFileListItemReducer = (selectors) => (state, action: { payload: { id: string }}) => {
  const { id } = action.payload
  const nodes = selectors.selectAll(state)

  const indexOfItemId = state.selectedItemsIds.indexOf(id)
  const indexOfNode = nodes.findIndex(node => node.id === id)

  if (state.selectedItemsIds.length < 2) {
    if (indexOfItemId === -1) {
      state.selectedItemsIds = [id]
    } else {
      state.selectedItemsIds = [...state.selectedItemsIds.slice(0, indexOfItemId), ...state.selectedItemsIds.slice(indexOfItemId + 1)]
    }
  } else {
    state.selectedItemsIds = [id]
  }

  if (state.selectedItemsIds.length) {
    state.lastSelectedIndexes = [indexOfNode]
  } else {
    state.lastSelectedIndexes = []
  }

  state.lastSelectedWithShiftIndex = null
}

export const selectAllFileListItemsReducer = (state, action) => {
  state.selectType = SelectType.ALL
  state.checkboxVisibility = CheckboxVisibilityType.VISIBLE
  state.selectedItemsIds = [...action.payload]
}

export const unselectAllFileListItemsReducer = (state) => {
  state.selectType = SelectType.NONE
  state.checkboxVisibility = CheckboxVisibilityType.HIDDEN
  state.selectedItemsIds = []
  state.lastSelectedWithShiftIndex = null
  state.lastSelectedIndexes = []
}

export const selectFileListItemWithPressedCtrlReducer = () => (state, action: { payload: { id: string }}) => {
  const { id } = action.payload

  const indexOfItemId = state.selectedItemsIds.indexOf(id)

  if (indexOfItemId === -1) {
    state.selectedItemsIds = [...state.selectedItemsIds, id]
  } else {
    state.selectedItemsIds = [...state.selectedItemsIds.slice(0, indexOfItemId), ...state.selectedItemsIds.slice(indexOfItemId + 1)]
  }

  state.lastSelectedWithShiftIndex = null
}

export const selectFileListItemWithPressedShiftReducer = (selectors) => (state, action: { payload: { id: string, items: any }}) => {
  const { id, items } = action.payload

  const nodes = selectors.selectAll(state)
  const indexOfNode = nodes.findIndex(node => node.id === id)
  const lastSelectedIndex = state.lastSelectedIndexes[state.lastSelectedIndexes.length - 1]
  const lastSelectedWithShiftIndex = state.lastSelectedWithShiftIndex

  // Get the parent_id of the current node
  const currentNode = nodes[indexOfNode]
  const parentId = currentNode?.parent_id

  // Filter nodes to only include those with the same parent_id
  const filteredNodes = nodes.filter(node => node.parent_id === parentId)
  const filteredIndexOfNode = filteredNodes.findIndex(node => node.id === id)
  const filteredLastSelectedIndex = filteredNodes.findIndex(node => node.id === nodes[lastSelectedIndex]?.id)

  let itemsIdsToExclude = []
  let newIds = []

  if (lastSelectedWithShiftIndex !== null) {
    if (filteredIndexOfNode < lastSelectedWithShiftIndex) {
      itemsIdsToExclude = [
        ...filteredNodes.slice(filteredIndexOfNode + 1, filteredLastSelectedIndex),
        ...filteredNodes.slice(filteredLastSelectedIndex + 1, lastSelectedWithShiftIndex + 1)
      ]
        .map(node => node.id)
    } else {
      itemsIdsToExclude = [
        ...filteredNodes.slice(lastSelectedWithShiftIndex, filteredLastSelectedIndex),
        ...filteredNodes.slice(filteredLastSelectedIndex + 1, filteredIndexOfNode)
      ]
        .map(node => node.id)
    }
  }

  const newState = state.selectedItemsIds.filter(id => !itemsIdsToExclude.includes(id))

  if (filteredIndexOfNode >= filteredLastSelectedIndex) {
    newIds = filteredNodes.slice(filteredLastSelectedIndex, filteredIndexOfNode + 1).map(node => node.id)
  } else {
    newIds = filteredNodes.slice(filteredIndexOfNode, filteredLastSelectedIndex).map(node => node.id)
  }

  state.selectedItemsIds = _.uniq([...newState, ...newIds])
  state.lastSelectedWithShiftIndex = indexOfNode

  changeFilesListCheckboxState(state.selectedItemsIds.length, items.length, state)
}
